module.exports = __webpack_public_path__ + "img/head_seven.8ee75e57.png";